import { Box, Button, Typography } from "@mui/material";
import { SITE_UNREACHABLE_TOKENS } from "../../tokens/design-tokens";

const BrokenPageIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    stroke={SITE_UNREACHABLE_TOKENS.color.icon}
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" />
    <path d="M14 2v6h6" />
    <circle cx="9" cy="13" r="0.8" fill={SITE_UNREACHABLE_TOKENS.color.icon} />
    <circle cx="15" cy="13" r="0.8" fill={SITE_UNREACHABLE_TOKENS.color.icon} />
    <path d="M9 17c1-1 2-1.5 3-1.5s2 0.5 3 1.5" />
  </svg>
);

const SiteUnreachable = () => {
  const hostname = location.hostname;

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: SITE_UNREACHABLE_TOKENS.color.background,
        display: "flex",
        justifyContent: "center",
        pt: "18vh",
        px: "24px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "520px",
          fontFamily: SITE_UNREACHABLE_TOKENS.fontFamily,
        }}
      >
        <Box sx={{ mb: "24px" }}>
          <BrokenPageIcon />
        </Box>

        <Typography
          component="h1"
          sx={{
            fontFamily: SITE_UNREACHABLE_TOKENS.fontFamily,
            fontSize: SITE_UNREACHABLE_TOKENS.fontSize.heading,
            fontWeight: SITE_UNREACHABLE_TOKENS.fontWeight.semiBold,
            color: SITE_UNREACHABLE_TOKENS.color.heading,
            lineHeight: 1.25,
            mb: "24px",
          }}
        >
          This site can't be reached
        </Typography>

        <Typography
          sx={{
            fontFamily: SITE_UNREACHABLE_TOKENS.fontFamily,
            fontSize: SITE_UNREACHABLE_TOKENS.fontSize.body,
            fontWeight: SITE_UNREACHABLE_TOKENS.fontWeight.regular,
            color: SITE_UNREACHABLE_TOKENS.color.body,
            lineHeight: 1.5,
            mb: "16px",
          }}
        >
          Check if there is a typo in {hostname}.
        </Typography>

        <Typography
          sx={{
            fontFamily: SITE_UNREACHABLE_TOKENS.fontFamily,
            fontSize: SITE_UNREACHABLE_TOKENS.fontSize.body,
            fontWeight: SITE_UNREACHABLE_TOKENS.fontWeight.regular,
            color: SITE_UNREACHABLE_TOKENS.color.body,
            lineHeight: 1.5,
            mb: "32px",
          }}
        >
          If spelling is correct,{" "}
          <Box
            component="span"
            onClick={handleReload}
            sx={{
              color: SITE_UNREACHABLE_TOKENS.color.primary,
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            try running Windows Network Diagnostics
          </Box>
          .
        </Typography>

        <Typography
          sx={{
            fontFamily: SITE_UNREACHABLE_TOKENS.fontFamily,
            fontSize: SITE_UNREACHABLE_TOKENS.fontSize.errorCode,
            fontWeight: SITE_UNREACHABLE_TOKENS.fontWeight.regular,
            color: SITE_UNREACHABLE_TOKENS.color.errorCode,
            letterSpacing: "0.4px",
            mb: "32px",
          }}
        >
          DNS_PROBE_FINISHED_NXDOMAIN
        </Typography>

        <Button
          variant="contained"
          onClick={handleReload}
          disableElevation
          sx={{
            backgroundColor: SITE_UNREACHABLE_TOKENS.color.primary,
            color: SITE_UNREACHABLE_TOKENS.color.buttonText,
            fontFamily: SITE_UNREACHABLE_TOKENS.fontFamily,
            fontSize: SITE_UNREACHABLE_TOKENS.fontSize.button,
            fontWeight: SITE_UNREACHABLE_TOKENS.fontWeight.medium,
            textTransform: "none",
            borderRadius: "999px",
            px: "24px",
            py: "8px",
            minWidth: "96px",
            "&:hover": {
              backgroundColor: SITE_UNREACHABLE_TOKENS.color.primaryHover,
            },
          }}
        >
          Reload
        </Button>
      </Box>
    </Box>
  );
};

export default SiteUnreachable;
